module.exports = __webpack_public_path__ + "img/info-circle-red.6649d312.svg";